import React from 'react';
import Badge from '@material-ui/core/Badge';
import { connect } from 'react-redux';
import { toggleCart } from '../actions/shoppingCart';

const Cart = (props: any) => {
  const openCart = () => {
    props.toggleCart();
  };

  return (
    <div className="mr-2 pl-3 " onClick={openCart}>
      <i
        className="fas fa-shopping-cart nav-cart  px-3 py-3 "
        style={{ fontSize: '20px', cursor: 'pointer', borderRadius: '99px' }}
      >
        <Badge
          badgeContent={
            props.shoppingCart.cart.length !== 0
              ? props.shoppingCart.cart
                  .map((product) => product.quantity)
                  .reduce((total, currentValue) => total + currentValue)
              : 0
          }
          color="error"
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        />
      </i>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  shoppingCart: state.cart,
  products: state.products,
});

export default connect(mapStateToProps, { toggleCart })(Cart);
